// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_TIC","expireSoon":"styles_expireSoon__3B0Pw"};